export default __webpack_public_path__ + "static/media/office_web-xs@1x.6d2f9413.jpg";